import { useEffect, useState } from 'react'
import useDebounce from '../../utils/hooks/useDebounce'

const LetterSpacingInput = ({ value, onChange }) => {
  function handleChange(evt) {
    onChange(evt.target.value)
  }
  return (
    <div className="letter-spacing-input">
      <label htmlFor="letter-spacing">Letter Spacing</label>
      <div className="flex items-center">
        <div className="flex items-center">
          <input
            type="range"
            min="0"
            max="25"
            value={value}
            onChange={handleChange}
            className="w-[150px]"
          />
        </div>
        <div className="w-[74px] relative ml-2 ">
          <input
            type="number"
            className="no-spinner"
            value={value}
            onChange={handleChange}
          />
          <div className="absolute right-0 top-0 h-full w-[30px] bg-gray-dark text-white-dark flex items-center justify-center rounded-r-half ">
            <span className="opacity-70">%</span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default LetterSpacingInput
